import styles from "./local-nav.style.scss?raw";

export class LocalNavComponent extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        // Inject external Webflow CSS at runtime (not bundled)
        const webflowCssId = 'local-nav-webflow-css';
        if (!document.getElementById(webflowCssId)) {
            const link = document.createElement('link');
            link.id = webflowCssId;
            link.rel = 'stylesheet';
            link.href = 'https://cdn.prod.website-files.com/68c920bf4c1a8f4733432a26/css/marketing-big.webflow.shared.731201ce2.min.css';
            document.head.appendChild(link);
        }
        // Inject component styles into the document head
        if (!document.getElementById('local-nav-styles')) {
            const styleElement = document.createElement('style');
            styleElement.id = 'local-nav-styles';
            styleElement.textContent = styles;
            document.head.appendChild(styleElement);
        }

        this.innerHTML = `
            <nav>
                <a href='/'><h1>The Big Whale</h1></a>
                <div class="nav-links-container">
                    <button class="button-v2 is-tertiary" id="test-btn">Trigger test Analytics Event</button>
                </div>
                <ul>
                    <li><a href="/">Home</a></li>
                    <li><a href="/src/tests/tbw-newsletter-form">Newsletter</a></li>
                </ul>
            </nav>
        `;

        // Set active state based on current page
        this.createTestAnalyticsTriggerButton();
    }

    createTestAnalyticsTriggerButton(): void {
        const authBtn = this.querySelector('#test-btn') as HTMLButtonElement;
        authBtn?.addEventListener('click', () => {
            window.tbwServices.analyticsService.track('test')
        });
    }
}